import { isRoot } from "interfaces/utils/identifyNodeTypes";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";

type WalkNodeApiAncestorsArgs<C> = {
  node: NodeApi | null;
  callback: (node: NodeApi, context: C | undefined) => C;
  context?: C;
};

export const walkNodeApiAncestors = <C>({
  node,
  callback,
  context,
}: WalkNodeApiAncestorsArgs<C>): C | undefined => {
  if (!node) {
    return context;
  }
  const newContext: C = callback(node, context);

  if (isRoot(node.data)) {
    return newContext;
  }

  return walkNodeApiAncestors({
    node: node.parent,
    callback,
    context: newContext,
  });
};
